import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  ANY_ORIGIN,
  APP_LOADED,
  MESSAGE_EVENT_TYPE
} from "../../constants/postMessages";
import * as actions from '../../actions/auth';
import LaunchError from "../LaunchError";
import './index.scss';

// The host replies to every app_loaded with the same single-use token, so both are once per page load.
let isAppLoadedPosted = false;
let isPayloadAccepted = false;

export class Auth extends Component {
  handleFrameLoaded = () => {
    if (!isAppLoadedPosted) {
      isAppLoadedPosted = true;
      window.parent.postMessage(APP_LOADED, ANY_ORIGIN);
    }
  }

  handleFrameTasks = (e) => {
    if (isPayloadAccepted || e.source !== window.parent) {
      return;
    }
    const payload = actions.parseContextPayload(e.data);
    if (payload) {
      isPayloadAccepted = true;
      this.props.signIn(payload);
    } else {
      this.props.handshakeRejected();
    }
  }

  componentDidMount() {
    window.addEventListener(MESSAGE_EVENT_TYPE, this.handleFrameTasks);
    this.handleFrameLoaded();
  }

  componentWillUnmount() {
    window.removeEventListener(MESSAGE_EVENT_TYPE, this.handleFrameTasks);
  }

  componentDidUpdate(prevProps) {
    if (this.props.credentials && !prevProps.credentials) {
      const {state} = this.props.history.location;
      this.props.history.push(state && state.previousPage ? state.previousPage : "/");
    }
  }

  render() {
    return (
        <div className="auth-container">
          {this.props.launchError ? <LaunchError/> : null}
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    credentials: state.auth.credentials,
    launchError: state.auth.launchError,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    signIn: (payload) => {
      dispatch(actions.signIn(payload));
    },
    handshakeRejected: () => {
      dispatch(actions.handshakeRejected());
    }
  }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Auth);
